import http from '@/httpAxios';

const getStoreInfo: (
  storeUuid: string,
  mode?: string | null,
  phone?: string | null,
  onFulfilled?: any,
  onRejected?: any
) => any = (storeUuid, mode, phone, onFulfilled, onRejected) => {
  const url = `/online/v2/store/${storeUuid}/storeInfo`;

  return http.get(
    url,
    {
      mode,
      phone,
    },
    {},
    onFulfilled,
    onRejected
  );
};

const StoreInfoService = {
  getStoreInfo,
};

export default StoreInfoService;
